import AdminIcon from '@mui/icons-material/SecurityRounded';
import Admin from './Admin';

const AdminModule = {
    icon: AdminIcon,
    list: Admin,
}; export default AdminModule;